import { useTranslation } from 'react-i18next';
import { PetPayForBuyersScreen } from 'shared/screens/petpay/for-buyers';
import { Page } from '@web/components/page';
import { Props } from 'shared/@types';
import { withServerProps } from '@web/library/with-server-props';

export default function PetPayForBuyers(props: Props) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(t('petpay.for_buyers.title'))
          .setDescription(t('petpay.for_buyers.description'))
      }
    >
      <PetPayForBuyersScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
